import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Box, Container } from '@chakra-ui/react';
import { Post } from '../../types';
import { resolveFields } from '../Fields';
import ArticleContainer from '../ArticleContainer';
import ArticleHero from '../ArticleHero';
import { splitFields } from './Page';
import { useConsenting } from '../../lib/consenting';
import { BlocksProvider } from '../../lib/blocks.context';
import { BlockRenderer } from '../Fields/BlockRenderer';

const LegalPage = ({
  fields,
  post_title: title,
  post_excerpt: leadText,
  featured_image: image,
}: Post) => {
  const {
    query: { revoke, ...query },
    replace,
  } = useRouter();
  const { consenting, revokeConsenting } = useConsenting();
  const [hero, contentFields] = resolveFields(fields);
  const { basicFields } = splitFields(contentFields);

  useEffect(() => {
    // revoke consenting if there's ?revoke in URL
    if (consenting && typeof revoke !== 'undefined') {
      revokeConsenting();
      replace({ query }, undefined, {
        shallow: true,
      });
    }
  }, [consenting, revoke, revokeConsenting, replace, query]);

  const heroProps = hero
    ? {
        title: hero.heading?.title || title,
        leadText: hero.text || leadText,
      }
    : { title, leadText, image };

  return (
    <ArticleContainer>
      {/* Box here is to avoid grid-gap between hero and content, which comes from ArticleContainer */}
      <Box>
        <ArticleHero {...heroProps} noMeta />
        <Container maxW="container.sm" variant="noSpacing">
          <BlocksProvider value={{ layoutType: 'basic' }}>
            <BlockRenderer blocks={basicFields} />
          </BlocksProvider>
        </Container>
      </Box>
    </ArticleContainer>
  );
};

export default LegalPage;
